export default [
    {
      path: "/user/task",
      name: "user.task",
      meta: {
        title: "积分任务",
      },
      component: () => import("./PointsTask"),
    },
    {
      path: "/user/PointStatement",
      name: "user.PointStatement",
      meta: {
        title: "签到规则",
      },
      component: () => import("./PointStatement"),
    },
    {
      path: "/user/viptask",
      name: "user.viptask",
      meta: {
        title: "VIP任务",
      },
      component: () => import("./VipTask.vue"),
    },
    {
      path: "/user/taskStatement",
      name: "user.taskStatement",
      meta: {
        title: "VIP等级任务说明",
      },
      component: () => import("./TaskStatement.vue"),
    },
  ];